<template>
	<div>
		<edit-page-gen :options="options" />
	</div>
</template>

<script>
import EditPageGen from './EditPageGen.vue'

const config = {
	options: {
		resource: 'user-groups'
	}
}

export default {
	name: 'UserGroupsEdit',
	components: { EditPageGen },
	data: () => config
}
</script>
